import React from 'react';
import classnames from 'classnames';
import {formattingDate} from '../../../utils/formatting';
import {Counter} from '../../../utils/counter';
import {
  checkIfTextEndsWithDot,
  getTextChunks,
} from '../../../utils/texts';
import styles from './styles.module.scss';

const mapTextChunks = (chunk, index, chunks) => (
  <span
    className={classnames({
      [styles.emptyLine]: chunk.length === 0,
    })}
    key={index + 1}
  >
    {chunk}
    {index === chunks.length - 1 ? checkIfTextEndsWithDot(chunk) : ''}
  </span>
);

export const getSection9 = (context) => {
  const {
    propertyLocation,
    propertyProperties,
    possessoryBackground,
    planningBackground,
    areaPropertiesPrices,
    officialDate,
    st8Other,
  } = context.data.pdfData;

  const counter = new Counter();

  const renderSection = ({
                           text,
                           id,
                           firstLineText = null,
                         }) => {
    if (!text) {
      return [];
    }

    const chunks = getTextChunks(text).map(mapTextChunks);

    return chunks.map((item, index) =>
      index === 0 ? (
        <ol
          key={`${id}-${index}`}
          start={counter.nextNumber()}
          className={classnames(styles.innerPadding, styles.lineContainer)}
          data-testid={id}
        >
          <li className={classnames(styles.itemText, styles.numberItem)}>
            {firstLineText}
            {item}
          </li>
        </ol>
      ) : (
        <div
          key={`${id}-${index}`}
          className={classnames(styles.innerPadding, styles.lineContainer)}
          data-testid={id}
        >
          <div className={classnames(styles.itemText, styles.numberItem)}>
            {item}
          </div>
        </div>
      )
    );
  };

  return [
    <div
      key="title"
      className={classnames(styles.itemText, styles.bold, styles.innerPadding)}
    >
      בבואי להעריך את שווי השוק של הנכס שבנדון הבאתי בחשבון את העקרונות,
      הגורמים והשיקולים הבאים:
    </div>,

    ...renderSection({
      text: propertyLocation,
      id: 'propertyLocation',
    }),

    ...renderSection({
      text: propertyProperties,
      id: 'propertyProperties',
    }),

    ...renderSection({
      text: possessoryBackground,
      id: 'possessoryBackground',
      firstLineText: <span>הרקע התכנוני - </span>,
    }),

    ...renderSection({
      text: planningBackground,
      id: 'planningBackground',
      firstLineText: <span>הרקע התכנוני - </span>,
    }),

    ...renderSection({
      text: areaPropertiesPrices,
      id: 'areaPropertiesPrices',
    }),

    officialDate && (
      <ol
        key="officialDate"
        start={counter.nextNumber()}
        className={classnames(styles.innerPadding, styles.lineContainer)}
      >
        <li className={classnames(styles.itemText, styles.numberItem)}>
          {`המועד הקובע לחוות הדעת ${formattingDate(officialDate)}.`}
        </li>
      </ol>
    ),

    ...renderSection({
      text: st8Other,
      id: 'st8Other',
    }),
  ];
};